import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import apiInstanceV2 from "../../Apis/AxiosV2";
import { FOODIE_MENU_SERVICE } from '../EndPoints';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const GetCafeteriaById = createAsyncThunk('cafeterias/getCafeteriaById ', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${FOODIE_MENU_SERVICE.getCafeteriaById}${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateCafeteria = createAsyncThunk("cafeterias/createCafeteria",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(FOODIE_MENU_SERVICE.createCafeteria, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateCafeteria = createAsyncThunk("cafeterias/updateCafeteria",async (params, { dispatch, getState }) => {
    const response = await apiInstance.put(FOODIE_MENU_SERVICE.updateCafeteria, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetAvailableDevicesByModeIds = createAsyncThunk('cafeterias/getAvailableDevicesByModeIds', async (params, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .post(FOODIE_MENU_SERVICE.getAvailableDevicesByModeIds, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetDepartmentsByCafeteriaId = createAsyncThunk('cafeterias/getDepartmentsByCafeteriaId', async (id, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .get(FOODIE_MENU_SERVICE.getDepartmentsByCafeteriaId(id))
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});


export const GetUsersByCafeteriaId = createAsyncThunk('cafeterias/getUsersByCafeteriaId', async (id, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .get(FOODIE_MENU_SERVICE.getUsersByCafeteriaId(id))
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
